import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=251c0c58&scoped=true&"
import script from "./CouponCard.vue?vue&type=script&lang=js&"
export * from "./CouponCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=251c0c58&lang=scss&scoped=true&"
import style1 from "./CouponCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c0c58",
  null
  
)

/* custom blocks */
import block0 from "./CouponCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CouponCard.vue"
export default component.exports